export const ROOT = "root";
export const MASTER = "master";
export const ADMINISTRACION = "administracion";
export const TECNICO = "tecnico";
export const JURIDICO = "juridico";
export const DESARROLLADOR = "desarrollador";
export const DIRECCION = "direccion";
